<template>
  <topHeader />
  <div class="user-profile-page">
    <div class="container">
      <div class="profile-layout">
        <!-- 左侧导航 -->
        <div class="profile-sidebar">
          <div class="sidebar-nav">
            <div 
              class="nav-item" 
              :class="{ active: activeTab === 'profile' }"
              @click="activeTab = 'profile'"
            >
              个人资料
            </div>
            <div 
              class="nav-item" 
              :class="{ active: activeTab === 'password' }"
              @click="activeTab = 'password'"
            >
              密码设置
            </div>
            <div 
              class="nav-item" 
              :class="{ active: activeTab === 'posts' }"
              @click="activeTab = 'posts'"
            >
              我的发布
            </div>
          </div>
        </div>

        <!-- 右侧内容区域 -->
        <div class="profile-content">
          <!-- 个人资料 -->
          <div v-show="activeTab === 'profile'" class="profile-section">
            <div class="section-title">个人资料</div>
            <div v-if="userInfoLoading" class="loading-text">加载中...</div>
            <div v-else class="info-list">
              <div class="info-item">
                <span class="info-label">账号:</span>
                <span class="info-value">{{ maskedPhone }}</span>
                <button 
                  class="view-all-btn" 
                  @click="togglePhoneDisplay" 
                  v-if="getFieldValue('phonenumber', 'userName', 'phone')"
                >
                  {{ showFullPhone ? '隐藏' : '查看全部' }}
                </button>
              </div>
              <div class="info-item">
                <span class="info-label">公司名称:</span>
                <span class="info-value">{{ getFieldValue('companyName', 'company', 'enterpriseName') || '未设置' }}</span>
              </div>
              <!-- <div class="info-item">
                <span class="info-label">法人姓名:</span>
                <span class="info-value">{{ getFieldValue('legalName', 'legalPerson', 'legalPersonName') || '未设置' }}</span>
              </div> -->
              <!-- <div class="info-item">
                <span class="info-label">批复文号:</span>
                <span class="info-value">{{ getFieldValue('approvalNumber', 'approvalNo', 'approvalDocument') || '未设置' }}</span>
              </div> -->
              <div class="info-item">
                <span class="info-label">账号注册日期:</span>
                <span class="info-value">{{ formatDate(getFieldValue('createTime')) || '未设置' }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">账号失效日期:</span>
                <span class="info-value">{{ formatDate(getFieldValue('dueTime', 'expiryTime', 'expireDate')) || '未设置' }}</span>
              </div>
            </div>
          </div>

          <!-- 密码设置 -->
          <div v-show="activeTab === 'password'" class="profile-section">
            <div class="section-title">密码设置</div>
            <div class="password-form">
              <div class="form-group">
                <label class="form-label">原密码:</label>
                <input 
                  type="password" 
                  v-model="passwordForm.oldPassword"
                  placeholder="请输入原密码"
                  class="form-input"
                  autocomplete="off"
                  readonly
                  onfocus="this.removeAttribute('readonly')"
                />
              </div>
              <div class="form-group">
                <label class="form-label">新密码:</label>
                <input 
                  type="password" 
                  v-model="passwordForm.newPassword"
                  placeholder="请输入新密码"
                  class="form-input"
                  autocomplete="new-password"
                  readonly
                  onfocus="this.removeAttribute('readonly')"
                />
              </div>
              <div class="form-group">
                <label class="form-label">确定新密码:</label>
                <input 
                  type="password" 
                  v-model="passwordForm.confirmPassword"
                  placeholder="请再次输入新密码"
                  class="form-input"
                  autocomplete="new-password"
                  readonly
                  onfocus="this.removeAttribute('readonly')"
                />
              </div>
              <button 
                class="confirm-btn" 
                @click="updatePassword"
                :disabled="passwordSubmitting"
              >
                {{ passwordSubmitting ? '提交中...' : '确认' }}
              </button>
            </div>
          </div>

          <!-- 我的发布 -->
          <div v-show="activeTab === 'posts'" class="profile-section">
            <div class="section-title">我的发布</div>
            <div v-if="loading" class="loading-text">加载中...</div>
            <div v-else-if="myPosts.length === 0" class="empty-text">暂无发布信息</div>
            <div v-else class="posts-list">
              <div 
                v-for="post in myPosts" 
                :key="post.id"
                class="post-item"
              >
                <div class="post-info">
                  <div class="post-meta">
                    <span class="post-label">审核状态:</span>
                    <span class="post-value">{{ post.reviewStatus === 1 ? '审核通过' : post.reviewStatus === 2 ? '审核未通过' : '未审核' }}</span>
                  </div>
                  <div class="post-meta">
                    <span class="post-label">审核意见:</span>
                    <span class="post-value">{{ post.reviewReason || '暂无审核意见' }}</span>
                  </div>
                  <div class="post-meta">
                    <span class="post-label">信息状态:</span>
                    <span class="post-value">{{ post.infoStatus === 1 ? '已发布' : post.infoStatus === 2 ? '已发布' : post.infoStatus === 3 ? '暂存' : '未发布' }}</span>
                  </div>
                  <div class="post-meta">
                    <span class="post-label">利用状态:</span>
                    <span class="post-value">{{ post.infoStatus === 2 ? '已利用' : '未利用' }}</span>
                  </div>
                  <div class="post-meta">
                    <span class="post-label">创建时间:</span>
                    <span class="post-value">{{ formatDate(post.createTime) }}</span>
                  </div>
                  <div class="post-meta">
                    <span class="post-label">交易性质:</span>
                    <span class="post-value">{{ post.infoType === '1' ? '找土' : '弃土' }}</span>
                  </div>
                  <div class="post-meta">
                    <span class="post-label">土方类型:</span>
                    <span class="post-value">{{ post.soilType || '未设置' }}</span>
                  </div>
                  <div class="post-meta">
                    <span class="post-label">地区:</span>
                    <span class="post-value">{{ post.region || '未设置' }}</span>
                  </div>
                  <div class="post-meta">
                    <span class="post-label">交易时间:</span>
                    <span class="post-value">
                      {{ formatDate(post.startTime) }} - {{ formatDate(post.endTime) }}
                    </span>
                  </div>
                  <div class="post-meta">
                    <span class="post-label">图片:</span>
                    <div class="post-images">
                      <img 
                        v-for="(img, index) in getPostImages(post.imageUrl)"
                        :key="index"
                        :src="img"
                        alt="图片"
                        class="post-image"
                      />
                    </div>
                  </div>
                </div>
                <!-- 利用状态为已利用时，置灰编辑、下架、删除按钮 ，已利用则可查看证书-->
                <div class="post-actions">
                  <button class="view-detail-btn" @click="goToEdit(post)" :class="{ disabled: post.infoStatus == 2 }" :disabled="post.infoStatus == 2">编  辑</button>

                  <button class="view-detail-btn" @click="goToUpdateStatus(post)" :class="{ disabled: post.infoStatus == 2 }" v-if="post.reviewStatus === 1" :disabled="post.infoStatus == 2">{{post.infoStatus == 1 ? '下  架' : '上  架'}}</button>

                  <button class="delete-btn" @click="handleDelete(post)" :class="{ disabled: post.infoStatus == 2 }" :disabled="post.infoStatus == 2">删  除</button>

                  <button class="view-detail-btn" @click="goToProcessApply(post)" >处理匹配申请</button>
                  
                  <button class="view-detail-btn" @click="goToViewCertificate(post)"  v-if="post.infoStatus == 2">下载证书</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 发布/编辑土方信息弹窗 -->
    <div v-if="showPublishModal" class="publish-modal" @click.self="closePublishModal">
      <div class="publish-modal-container">
        <div class="publish-modal-header">
          <h3>{{ editPostData ? '编辑土方信息' : '发布土方信息' }}</h3>
          <button class="close-btn" @click="closePublishModal">×</button>
        </div>
        <div class="publish-modal-content">
          <Publish 
            :val="editPostData ? (editPostData.infoType === '1' ? '1' : '2') : '0'" 
            :initialFormData="editFormData"
            :editId="editPostData ? editPostData.id : null"
            @close="closePublishModal"
            @success="handlePublishSuccess"
          />
        </div>
      </div>
    </div>

    <!-- 证书预览弹窗 -->
    <div v-if="showCertificateModal" class="certificate-modal" @click.self="closeCertificateModal">
      <div class="certificate-modal-content">
        <div class="certificate-modal-header">
          <h3>证书预览</h3>
          <button class="close-btn" @click="closeCertificateModal">×</button>
        </div>
        <div class="certificate-modal-body">
          <div class="certificate-image-wrapper">
            <img 
              :src="certificateImageUrl" 
              alt="证书" 
              class="certificate-image"
              @error="handleCertificateImageError"
            />
          </div>
          <div class="certificate-modal-actions">
            <button class="download-btn" @click="downloadCertificate">
              <span>⬇</span>
              下载证书
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- 处理匹配申请弹窗 -->
    <div v-if="showProcessApplyModal" class="process-apply-modal" @click.self="closeProcessApplyModal">
      <div class="process-apply-modal-content">
        <div class="process-apply-modal-header">
          <h3>匹配申请</h3>
          <button class="close-btn" @click="closeProcessApplyModal">×</button>
        </div>
        <div class="process-apply-modal-body">
          <div v-if="applyListLoading" class="loading-text">加载中...</div>
          <div v-else-if="applyList.length === 0" class="empty-text">暂无待处理的匹配申请</div>
          <div v-else class="apply-list">
            <div 
              v-for="apply in applyList" 
              :key="apply.id"
              class="apply-item"
              :class="{ active: selectedApplyId === apply.id }"
              @click="selectedApplyId = apply.id"
            >
              <div class="apply-radio">
                <input 
                  type="radio" 
                  :id="'apply-' + apply.id"
                  :value="apply.id"
                  v-model="selectedApplyId"
                />
                <label :for="'apply-' + apply.id"></label>
              </div>
              <div class="apply-info">
                <div class="apply-title">{{ apply.soilInfo.title }}</div>
                <div class="apply-details">
                  <div class="apply-detail-item" v-if="apply.createTime">
                    <span class="detail-label">申请时间:</span>
                    <span class="detail-value">{{ formatDate(apply.createTime) }}</span>
                  </div>
                  <div class="apply-detail-item" >
                    <span class="detail-label">土方地点:</span>
                    <span class="detail-value">{{ apply.soilInfo.address}}</span>
                  </div>
                  <div class="apply-detail-item">
                    <span class="detail-label">土方类型:</span>
                    <span class="detail-value">{{ apply.soilInfo.soilType }}</span>
                  </div>
                  <div class="apply-detail-item">
                    <span class="detail-label">土方量:</span>
                    <span class="detail-value">{{ apply.soilInfo.volume }}{{ apply.soilInfo.volumeUnit || '立方' }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="process-apply-modal-footer">
          <button class="cancel-btn" @click="closeProcessApplyModal">取消</button>
          <button class="reject-btn" @click="submitProcessApply(false)" :disabled="!selectedApplyId || applyListLoading">拒绝</button>
          <button class="submit-btn" @click="submitProcessApply(true)" :disabled="!selectedApplyId || applyListLoading">同意</button>
        </div>
      </div>
    </div>
  </div>
  <SiteFooter />
</template>

<script>
import topHeader from './top-Header.vue'
import SiteFooter from './Footer.vue'
import Publish from './publish.vue'
import { getUserInfo, updatePassword, logout, getMySoilInfoList, updateSoilInfoStatus, removeSoilInfo, getMySoilApplyListPending, processSoilApply, downloadWitnessFile } from '@/api/user'

export default {
  name: 'UserProfile',
  components: {
    topHeader,
    SiteFooter,
    Publish
  },
  data() {
    return {
      activeTab: 'profile',
      userInfo: {},
      passwordForm: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      myPosts: [],
      loading: false,
      userInfoLoading: false,
      showFullPhone: false,
      passwordSubmitting: false,
      showPublishModal: false,
      editPostData: null,
      editFormData: {},
      // 证书预览相关
      showCertificateModal: false,
      certificateImageUrl: '',
      // 处理匹配申请相关
      showProcessApplyModal: false,
      applyList: [],
      selectedApplyId: null,
      applyListLoading: false,
      currentPostId: null // 当前处理的土方信息ID
    }
  },
  computed: {
    maskedPhone() {
      if (this.showFullPhone) {
        const phone = this.getFieldValue('phonenumber', 'userName', 'phone') || '';
        return phone || '未设置';
      }
      const phone = this.getFieldValue('phonenumber', 'userName', 'phone') || '';
      if (!phone || phone.length < 7) return '';
      const phoneStr = String(phone);
      const start = phoneStr.slice(0, 3);
      const end = phoneStr.slice(-4);
      return `${start}****${end}`;
    }
  },
  mounted() {
    this.loadUserInfo();
    this.loadMyPosts();
  },
  methods: {
    async loadUserInfo() {
      this.userInfoLoading = true;
      try {
        const res = await getUserInfo();
        console.log('用户信息接口返回:', res);
        
        // 适配不同的返回格式
        if (res) {
          // 格式1: { user: {...} }
          if (res.user) {
            this.userInfo = res.user;
          }
          // 格式2: { code: 200, data: {...} } - 优先检查带 code 的格式
          else if (res.code === 200 && res.data) {
            this.userInfo = res.data;
          }
          // 格式3: { data: {...} }
          else if (res.data) {
            this.userInfo = res.data;
          }
          // 格式4: 直接返回用户对象
          else if (res.phonenumber || res.companyName || res.userName) {
            this.userInfo = res;
          }
          else {
            console.warn('用户信息返回格式未识别:', res);
            this.userInfo = {};
          }
        } else {
          this.userInfo = {};
        }
      } catch (error) {
        console.error('获取用户信息失败:', error);
        this.userInfo = {};
        // 可以显示错误提示
        // alert('获取用户信息失败，请稍后再试');
      } finally {
        this.userInfoLoading = false;
      }
    },
    async loadMyPosts() {
      this.loading = true;
      try {
        // 获取当前用户发布的所有土方信息
        const res = await getMySoilInfoList({ pageNum: 1, pageSize: 100 });
        console.log('我的发布接口返回:', res);
        
        // 适配不同的返回格式
        let list = [];
        if (res) {
          // 格式1: { rows: [...] }
          if (res.rows && Array.isArray(res.rows)) {
            list = res.rows;
          }
          // 格式2: { data: { rows: [...] } }
          else if (res.data && res.data.rows && Array.isArray(res.data.rows)) {
            list = res.data.rows;
          }
          // 格式3: { data: [...] }
          else if (res.data && Array.isArray(res.data)) {
            list = res.data;
          }
          // 格式4: { code: 200, data: [...] }
          else if (res.code === 200 && res.data) {
            if (Array.isArray(res.data)) {
              list = res.data;
            } else if (res.data.rows && Array.isArray(res.data.rows)) {
              list = res.data.rows;
            }
          }
          // 格式5: 直接返回数组
          else if (Array.isArray(res)) {
            list = res;
          }
        }
        
        this.myPosts = list || [];
      } catch (error) {
        console.error('获取我的发布失败:', error);
        this.myPosts = [];
      } finally {
        this.loading = false;
      }
    },
    formatDate(dateStr) {
      if (!dateStr) return '';
      const s = String(dateStr).trim();
      if (/^\d{4}-\d{2}$/.test(s)) {
        const [y, m] = s.split('-');
        return `${y}年${m}月`;
      }
      const date = new Date(s);
      if (Number.isNaN(date.getTime())) return s;
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}年${month}月${day}日`;
    },
    togglePhoneDisplay() {
      this.showFullPhone = !this.showFullPhone;
    },
    // 获取字段值，支持多个可能的字段名
    getFieldValue(...fieldNames) {
      for (const fieldName of fieldNames) {
        if (this.userInfo && this.userInfo[fieldName] !== undefined && this.userInfo[fieldName] !== null && this.userInfo[fieldName] !== '') {
          return this.userInfo[fieldName];
        }
      }
      return '';
    },
    async updatePassword() {
      // 表单验证
      if (!this.passwordForm.oldPassword) {
        alert('请输入原密码');
        return;
      }
      if (!this.passwordForm.newPassword) {
        alert('请输入新密码');
        return;
      }
      if (this.passwordForm.newPassword.length < 6) {
        alert('新密码长度不能少于6位');
        return;
      }
      if (this.passwordForm.newPassword !== this.passwordForm.confirmPassword) {
        alert('两次输入的新密码不一致');
        return;
      }
      
      this.passwordSubmitting = true;
      try {
        const params = {
          oldPassword: this.passwordForm.oldPassword,
          newPassword: this.passwordForm.newPassword,
          confirmPassword: this.passwordForm.confirmPassword
        };
        
        console.log('修改密码请求参数:', params);
        const res = await updatePassword(params);
        console.log('修改密码接口返回:', res);
        
        // 处理成功响应（适配不同的返回格式）
        let isSuccess = false;
        if (res) {
          // 格式1: { code: 200, msg: '成功' }
          if (res.code === 200) {
            isSuccess = true;
            alert(res.msg || '密码修改成功！请重新登录');
          }
          // 格式2: 直接返回成功（无code字段）
          else if (!res.code) {
            isSuccess = true;
            alert('密码修改成功！请重新登录');
          }
          // 格式3: 其他情况
          else {
            alert(res.msg || '密码修改失败，请稍后再试');
          }
        } else {
          alert('密码修改失败，请稍后再试');
        }
        
        // 如果密码修改成功，执行退出登录
        if (isSuccess) {
          await this.handleLogoutAfterPasswordChange();
        }
      } catch (error) {
        console.error('修改密码失败:', error);
        // 处理错误响应
        const errorMsg = error?.response?.data?.msg || error?.message || '修改密码失败，请稍后再试';
        alert(errorMsg);
      } finally {
        this.passwordSubmitting = false;
      }
    },
    // 修改密码成功后退出登录
    async handleLogoutAfterPasswordChange() {
      try {
        // 调用退出登录接口
        await logout();
      } catch (e) {
        // 即使接口失败，也继续本地清理，避免卡死
        console.warn('调用退出登录接口失败，继续本地清理', e);
      }
      
      // 清除token和登录状态
      localStorage.removeItem('token');
      localStorage.removeItem('isLoggedIn');
      
      // 清除用户信息
      this.userInfo = {};
      
      // 重置表单
      this.passwordForm = {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      };
      
      // 跳转到首页
      this.$router.push('/').then(() => {
        // 跳转成功后，尝试显示登录弹窗
        if (window.showLoginDialog) {
          setTimeout(() => {
            window.showLoginDialog();
          }, 300);
        }
      });
    },
    getStatusText(status) {
      const statusMap = {
        0: '待交易',
        1: '交易中',
        2: '已完成'
      };
      return statusMap[status] || '未知';
    },
    // 编辑发布信息
    goToEdit(post) {
      this.editPostData = post;
      
      // 将后端数据转换为表单数据格式
      const imageUrls = post.imageUrl ? (post.imageUrl.split(',').filter(url => url.trim())) : [];
      const imageBaseUrl = 'https://qtzp.qhdbigdata.com/qtzp-api/upload/';
      
      this.editFormData = {
        infoType: post.infoType !== undefined && post.infoType !== null ? String(post.infoType) : '',
        region: post.region || '',
        soilType: post.soilType || '',
        mapLocation: post.longitude && post.latitude ? `${post.longitude},${post.latitude}` : '',
        detailAddress: post.address || '',
        startTime: post.startTime || '',
        endTime: post.endTime || '',
        area: post.volume ? String(post.volume) : '',
        areaUnit: post.volumeUnit || '立方',
        transferType: post.transferType || '经营权出租',
        price: post.price ? String(post.price) : '',
        priceUnit: post.priceUnit || '元',
        years: post.years || '',
        images: imageUrls.map(url => {
          // 处理图片路径：如果是完整URL则使用，否则拼接基础路径
          let fullUrl = url;
          let fileName = url;
          
          if (!url.startsWith('http') && !url.startsWith('data:')) {
            // 如果路径以 /upload/ 开头，需要转换为 /upload/qtzp/
            if (url.startsWith('/upload/')) {
              // 去掉开头的 /upload，然后拼接 /upload/qtzp/
              const pathAfterUpload = url.replace(/^\/upload\//, '');
              fullUrl = `https://qtzp.qhdbigdata.com/qtzp-api/upload/${pathAfterUpload}`;
              // fileName 保持原路径（完整相对路径），用于提交时使用
              fileName = url;
            } else if (url.startsWith('/')) {
              // 其他以 / 开头的路径，直接拼接基础URL
              fullUrl = `https://qtzp.qhdbigdata.com/qtzp-api/upload${url}`;
              fileName = url;
            } else {
              // 否则使用标准路径
              fullUrl = imageBaseUrl + url;
              // fileName 保持原路径
              fileName = url;
            }
          } else if (url.startsWith('http')) {
            // 如果是完整URL，提取相对路径作为fileName
            try {
              const urlObj = new URL(url);
              fileName = urlObj.pathname;
            } catch (e) {
              // 如果解析失败，使用原URL
              fileName = url;
            }
          }
          
          return {
            url: fullUrl,
            fileName: fileName
          };
        }),
        title: post.title || '',
        description: post.detail || '',
        contactName: post.contactName || '',
        contactPhone: post.contactPhone || '',
        application: post.application || '',
        creditCode: post.creditCode || '',
        projectCode: post.projectCode || '',
        companyName: post.companyName || '',
        projectName: post.projectName || ''
      };
      
      console.log('编辑数据:', this.editFormData);
      console.log('编辑数据中的图片:', this.editFormData.images);
      this.showPublishModal = true;
    },
    // 关闭发布弹窗
    closePublishModal() {
      this.showPublishModal = false;
      this.editPostData = null;
      this.editFormData = {};
    },
    // 发布/编辑成功后的回调
    handlePublishSuccess() {
      this.closePublishModal();
      // 重新加载我的发布列表
      this.loadMyPosts();
    },
    getPostImages(imageUrl) {
      if (!imageUrl) return [];
      const imageBaseUrl = 'https://qtzp.qhdbigdata.com/qtzp-api/upload/';
      const images = imageUrl.split(',').filter(img => img && img.trim());
      return images.map(img => {
        return img.startsWith('http') ? img : imageBaseUrl + img;
      }).slice(0, 2); // 最多显示2张图片
    },
    goToDetail(id) {
      this.$router.push({
        path: '/product/' + id
      });
    },
    // 上架/下架土方信息
    async goToUpdateStatus(post) {
      if (!post || !post.id) {
        alert('信息异常，无法操作');
        return;
      }
      
      // 根据当前状态决定新状态：如果当前是1（上架），则下架（0）；如果当前是0（下架），则上架（1）
      const currentStatus = post.infoStatus === 1 ? 1 : 0;
      const newStatus = currentStatus === 1 ? 0 : 1;
      const actionText = newStatus === 1 ? '上架' : '下架';
      
      // 确认操作
      if (!confirm(`确定要${actionText}这条信息吗？`)) {
        return;
      }
      
      try {
        await updateSoilInfoStatus({
          id: post.id,
          infoStatus: newStatus
        });
        
        alert(`${actionText}成功！`);
        // 重新加载我的发布列表
        this.loadMyPosts();
      } catch (error) {
        console.error(`${actionText}失败:`, error);
        const errorMsg = error?.response?.data?.msg || error?.message || `${actionText}失败，请稍后再试`;
        alert(errorMsg);
      }
    },
    // 删除土方信息
    async handleDelete(post) {
      if (!post || !post.id) {
        alert('信息异常，无法删除');
        return;
      }
      
      // 确认删除
      if (!confirm('确定要删除这条信息吗？删除后无法恢复！')) {
        return;
      }
      
      try {
        await removeSoilInfo(post.id);
        alert('删除成功！');
        // 重新加载我的发布列表
        this.loadMyPosts();
      } catch (error) {
        console.error('删除失败:', error);
        const errorMsg = error?.response?.data?.msg || error?.message || '删除失败，请稍后再试';
        alert(errorMsg);
      }
    },
    // 下载证书
    async goToViewCertificate(post) {
      if (!post) {
        alert('信息异常，无法下载证书');
        return;
      }
      
      // 获取申请ID，优先使用 applyId，如果没有则使用 post.id
      const applyId = post.applyId || post.id;
      
      if (!applyId) {
        alert('无法获取申请ID，无法下载证书');
        return;
      }
      
      try {
        // 调用下载接口
        const response = await downloadWitnessFile(applyId);
        
        // 检查响应是否有效
        if (!response || !response.data) {
          throw new Error('服务器返回无效响应');
        }
        
        // 处理响应，创建下载链接
        // response 应该是完整的 axios response 对象（因为 responseType: 'blob'）
        let blob = response.data;
        
        // 检查是否是有效的 Blob 对象
        if (!(blob instanceof Blob)) {
          throw new Error('服务器返回的数据格式不正确');
        }
        
        // 检查是否是错误响应（错误响应可能是 JSON 格式的 blob）
        if (blob.type && blob.type.includes('application/json')) {
          const text = await blob.text();
          try {
            const errorData = JSON.parse(text);
            throw new Error(errorData.msg || errorData.message || '下载失败');
          } catch (e) {
            // 如果解析失败，可能是其他错误
            throw new Error('下载失败，服务器返回错误信息');
          }
        }
        
        // 检查文件大小，如果太小可能是错误响应
        if (blob.size < 100) {
          // 尝试读取内容检查是否是错误信息
          const text = await blob.text();
          if (text && text.length < 200) {
            try {
              const errorData = JSON.parse(text);
              throw new Error(errorData.msg || errorData.message || '下载失败');
            } catch (e) {
              // 如果不是 JSON，可能是其他错误信息
              if (text.includes('error') || text.includes('Error') || text.includes('异常')) {
                throw new Error('下载失败：' + text);
              }
            }
          }
        }
        
        // 创建下载链接
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        
        // 从响应头获取文件名
        let fileName = `证书_${applyId}_${new Date().getTime()}.pdf`;
        const contentDisposition = response.headers?.['content-disposition'] || response.headers?.['Content-Disposition'] || '';
        
        if (contentDisposition) {
          // 匹配 filename= 或 filename*= 格式
          // 支持格式：filename="xxx" 或 filename=xxx 或 filename*=UTF-8''xxx
          const fileNameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
          if (fileNameMatch && fileNameMatch[1]) {
            fileName = fileNameMatch[1].replace(/['"]/g, '');
            // 处理 URL 编码的文件名（后端使用了 URLEncoder.encode）
            try {
              // 先尝试 decodeURIComponent，如果失败则尝试 decodeURI
              fileName = decodeURIComponent(fileName);
            } catch (e) {
              try {
                fileName = decodeURI(fileName);
              } catch (e2) {
                // 如果都失败，使用原始文件名
                console.warn('文件名解码失败，使用原始文件名:', fileName);
              }
            }
          }
        }
        
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        
        alert('证书下载成功');
      } catch (error) {
        console.error('下载证书失败:', error);
        // 提取错误信息
        let errorMsg = '下载证书失败，请稍后再试';
        
        if (error.message) {
          errorMsg = error.message;
        } else if (error.response) {
          // 尝试从响应中获取错误信息
          if (error.response.data) {
            if (error.response.data instanceof Blob) {
              // 如果是 Blob，尝试读取
              try {
                const text = await error.response.data.text();
                const errorData = JSON.parse(text);
                errorMsg = errorData.msg || errorData.message || errorMsg;
              } catch (e) {
                // 如果解析失败，使用状态码信息
                if (error.response.status) {
                  errorMsg = `下载失败，状态码: ${error.response.status}`;
                }
              }
            } else if (error.response.data.msg) {
              errorMsg = error.response.data.msg;
            } else if (error.response.data.message) {
              errorMsg = error.response.data.message;
            }
          } else if (error.response.status) {
            if (error.response.status === 400) {
              errorMsg = '请求参数错误，无法下载证书';
            } else if (error.response.status === 500) {
              errorMsg = '服务器内部错误，请稍后再试';
            } else {
              errorMsg = `下载失败，状态码: ${error.response.status}`;
            }
          }
        }
        
        alert(errorMsg);
      }
    },
    // 关闭证书预览弹窗
    closeCertificateModal() {
      this.showCertificateModal = false;
      this.certificateImageUrl = '';
    },
    // 下载证书图片
    downloadCertificate() {
      if (!this.certificateImageUrl) {
        alert('证书图片不存在');
        return;
      }
      
      try {
        // 如果是跨域图片，需要先获取图片并转换为 blob
        if (this.certificateImageUrl.startsWith('http')) {
          fetch(this.certificateImageUrl, {
            mode: 'cors'
          })
            .then(response => {
              if (!response.ok) {
                throw new Error('网络响应错误');
              }
              return response.blob();
            })
            .then(blob => {
              const url = window.URL.createObjectURL(blob);
              const link = document.createElement('a');
              link.href = url;
              link.download = `证书_${new Date().getTime()}.jpg`;
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              window.URL.revokeObjectURL(url);
            })
            .catch(error => {
              console.error('下载失败:', error);
              // 如果 fetch 失败，尝试直接打开新窗口
              alert('下载失败，已在新窗口打开图片，您可以右键保存');
              window.open(this.certificateImageUrl, '_blank');
            });
        } else {
          // 创建临时链接下载
          const link = document.createElement('a');
          link.href = this.certificateImageUrl;
          link.download = `证书_${new Date().getTime()}.jpg`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      } catch (error) {
        console.error('下载证书失败:', error);
        // 如果下载失败，尝试在新窗口打开图片
        alert('下载失败，已在新窗口打开图片，您可以右键保存');
        window.open(this.certificateImageUrl, '_blank');
      }
    },
    // 处理证书图片加载错误
    handleCertificateImageError(event) {
      console.error('证书图片加载失败:', event.target.src);
      alert('证书图片加载失败，请检查图片地址是否正确');
      event.target.style.display = 'none';
    },
    // 处理匹配申请
    async goToProcessApply(post) {
      if (!post || !post.id) {
        alert('信息异常，无法处理匹配申请');
        return;
      }
      
      this.currentPostId = post.id;
      this.showProcessApplyModal = true;
      this.selectedApplyId = null;
      await this.loadApplyList();
    },
    // 加载待处理的匹配申请列表
    async loadApplyList() {
      if (!this.currentPostId) {
        return;
      }
      
      this.applyListLoading = true;
      try {
        const res = await getMySoilApplyListPending({
          targetSoilId: this.currentPostId
        });
        
        console.log('待处理申请列表接口返回:', res);
        
        // 适配不同的返回格式
        let list = [];
        if (res) {
          // 格式1: { rows: [...] }
          if (res.rows && Array.isArray(res.rows)) {
            list = res.rows;
          }
          // 格式2: { data: { rows: [...] } }
          else if (res.data && res.data.rows && Array.isArray(res.data.rows)) {
            list = res.data.rows;
          }
          // 格式3: { data: [...] }
          else if (res.data && Array.isArray(res.data)) {
            list = res.data;
          }
          // 格式4: { code: 200, data: [...] }
          else if (res.code === 200 && res.data) {
            if (Array.isArray(res.data)) {
              list = res.data;
            } else if (res.data.rows && Array.isArray(res.data.rows)) {
              list = res.data.rows;
            }
          }
          // 格式5: 直接返回数组
          else if (Array.isArray(res)) {
            list = res;
          }
        }
        
        this.applyList = list || [];
      } catch (error) {
        console.error('获取待处理申请列表失败:', error);
        const errorMsg = error?.response?.data?.msg || error?.message || '获取申请列表失败，请稍后再试';
        alert(errorMsg);
        this.applyList = [];
      } finally {
        this.applyListLoading = false;
      }
    },
    // 关闭处理匹配申请弹窗
    closeProcessApplyModal() {
      this.showProcessApplyModal = false;
      this.applyList = [];
      this.selectedApplyId = null;
      this.currentPostId = null;
    },
    // 提交处理匹配申请
    async submitProcessApply(agree) {
      if (!this.selectedApplyId) {
        alert('请选择要处理的申请');
        return;
      }
      
      if (!this.currentPostId) {
        alert('信息异常，无法提交');
        return;
      }
      
      try {
        const res = await processSoilApply({
          applyId: this.selectedApplyId,
          // targetSoilId: this.currentPostId,
          agree: agree
        });
        
        console.log('处理匹配申请接口返回:', res);
        
        // 处理响应
        if (res && res.code === 200) {
          alert(agree ? '同意申请成功' : '拒绝申请成功');
          this.closeProcessApplyModal();
          // 重新加载我的发布列表
          this.loadMyPosts();
        } else {
          const errorMsg = res?.msg || res?.message || '处理失败，请稍后再试';
          alert(errorMsg);
        }
      } catch (error) {
        console.error('处理匹配申请失败:', error);
        const errorMsg = error?.response?.data?.msg || error?.message || '处理失败，请稍后再试';
        alert(errorMsg);
      }
    },
    // 获取申请状态文本
    getApplyStatusText(status) {
      const statusMap = {
        0: '待处理',
        1: '已通过',
        2: '已拒绝'
      };
      return statusMap[status] || '未知';
    }
  }
}
</script>

<style scoped>
.user-profile-page {
  min-height: 500px;
  background-color: #f5f5f5;
  padding: 20px 0;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.profile-layout {
  display: flex;
  gap: 20px;
  margin-top: 20px;
}

.profile-sidebar {
  width: 200px;
  background: #422C27;
  border-radius: 8px;
  padding: 20px;
  flex-shrink: 0;
}

.sidebar-title {
  color: white;
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 20px;
}

.sidebar-nav {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.nav-item {
  padding: 12px 16px;
  color: white;
  cursor: pointer;
  border-radius: 4px;
  transition: all 0.3s;
  font-size: 14px;
}

.nav-item:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.nav-item.active {
  background-color: rgba(255, 255, 255, 0.2);
  font-weight: 600;
}

.profile-content {
  flex: 1;
  background: white;
  border-radius: 8px;
  padding: 30px 70px 70px 70px;
  /* min-height: 600px; */
}

.section-title {
  font-size: 20px;
  font-weight: 600;
  color: #333;
  margin-bottom: 30px;
  padding-bottom: 10px;
  border-bottom: 2px solid #f0f0f0;
}

/* 个人资料样式 */
.info-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.info-item {
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 10px 0;
  /* border-bottom: 1px solid #f0f0f0; */
}

.info-label {
  min-width: 120px;
  text-align: right;
  color: #666;
  font-size: 14px;
}

.info-value {
  flex: 1;
  color: #333;
  text-align: left;
  font-size: 14px;
}

.view-all-btn {
  padding: 6px 16px;
  background: #422C27;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.3s;
}

.view-all-btn:hover {
  background: #5a3d35;
}

/* 密码设置样式 */
.password-form {
  max-width: 500px;
  margin: 0 auto;
}

.form-group {
  margin-bottom: 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
}

.form-label {
  display: block;
  margin-bottom: 8px;
  color: #333;
  font-size: 14px;
  font-weight: 500;
  width: 100px;
  text-align: right;
}

.form-input {
  width: 100%;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  transition: border-color 0.3s;
}

.form-input:focus {
  outline: none;
  border-color: #422C27;
}

.confirm-btn {
  padding: 12px 30px;
  background: #422C27;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.3s;
  margin-top: 20px;
}

.confirm-btn:hover:not(:disabled) {
  background: #5a3d35;
}

.confirm-btn:disabled {
  background: #ccc;
  cursor: not-allowed;
  opacity: 0.6;
}

/* 我的发布样式 */
.loading-text,
.empty-text {
  text-align: center;
  color: #999;
  padding: 40px 0;
  font-size: 14px;
}

.posts-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.post-item {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 20px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  transition: all 0.3s;
}

.post-item:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.post-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.post-meta {
  display: flex;
  align-items: center;
  gap: 10px;
}

.post-actions {
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: flex-end;
  .disabled {
    background: #ccc;
    cursor: not-allowed;
    opacity: 0.6;
  }
}

/* 发布/编辑弹窗样式 */
.publish-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow-y: auto;
  padding: 20px;
}

.publish-modal-container {
  background: white;
  border-radius: 12px;
  width: 90%;
  max-width: 1200px;
  max-height: 95vh;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
}

.publish-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #eee;
  background: #f8f9fa;
  flex-shrink: 0;
}

.publish-modal-header h3 {
  margin: 0;
  color: #333;
  font-size: 20px;
}

.publish-modal-header .close-btn {
  background: none;
  border: none;
  font-size: 28px;
  color: #999;
  cursor: pointer;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.3s;
}

.publish-modal-header .close-btn:hover {
  color: #333;
}

.publish-modal-content {
  flex: 1;
  overflow-y: auto;
  padding: 0;
}

.publish-modal-content .land-supply-page {
  margin: 0;
  padding: 20px;
  background: white;
}

.publish-modal-content .container {
  padding: 0;
}

.publish-modal-content .form-wrapper {
  margin: 0;
  box-shadow: none;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .publish-modal {
    padding: 10px;
  }

  .publish-modal-container {
    width: 95%;
    max-height: 98vh;
  }

  .publish-modal-content {
    padding: 10px;
  }
}

.post-label {
  min-width: 100px;
  color: #666;
  font-size: 14px;
}

.post-value {
  color: #333;
  font-size: 14px;
}

.post-images {
  display: flex;
  gap: 10px;
  margin-top: 5px;
}

.post-image {
  width: 80px;
  height: 80px;
  object-fit: cover;
  border-radius: 4px;
  border: 1px solid #e0e0e0;
}

.view-detail-btn {
  padding: 8px 16px;
  background: #422C27;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.3s;
  white-space: nowrap;
  min-width: 100px;
}

.view-detail-btn:hover {
  background: #a17f76;
}

.delete-btn {
  padding: 8px 16px;
  background: #dc3545;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.3s;
  white-space: nowrap;
  min-width: 100px;
}

.delete-btn:hover {
  background: #c82333;
}

/* 证书预览弹窗样式 */
.certificate-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.certificate-modal-content {
  background: white;
  border-radius: 12px;
  width: 90%;
  max-width: 900px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
}

.certificate-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #eee;
  background: #f8f9fa;
  border-radius: 12px 12px 0 0;
}

.certificate-modal-header h3 {
  margin: 0;
  font-size: 20px;
  font-weight: bold;
  color: #333;
}

.certificate-modal-body {
  flex: 1;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: auto;
}

.certificate-image-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
  background: #f5f5f5;
  border-radius: 8px;
  padding: 20px;
  min-height: 400px;
}

.certificate-image {
  max-width: 100%;
  max-height: 70vh;
  height: auto;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  object-fit: contain;
}

.certificate-modal-actions {
  display: flex;
  justify-content: center;
  gap: 15px;
  width: 100%;
}

.download-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 24px;
  background: #422C27;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
}

.download-btn:hover {
  background: #E4CEC2;
  color: #333;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.download-btn span {
  font-size: 18px;
  display: inline-block;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .certificate-modal-content {
    width: 95%;
    max-width: 95%;
  }

  .certificate-image {
    max-height: 60vh;
  }

  .certificate-image-wrapper {
    min-height: 300px;
    padding: 10px;
  }
}

/* 处理匹配申请弹窗样式 */
.process-apply-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.process-apply-modal-content {
  background: white;
  border-radius: 12px;
  width: 90%;
  max-width: 700px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
}

.process-apply-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #eee;
  background: #f8f9fa;
  border-radius: 12px 12px 0 0;
}

.process-apply-modal-header h3 {
  margin: 0;
  font-size: 20px;
  font-weight: bold;
  color: #333;
}

.process-apply-modal-body {
  flex: 1;
  padding: 20px;
  overflow-y: auto;
  min-height: 200px;
}

.loading-text,
.empty-text {
  text-align: center;
  padding: 40px 20px;
  color: #666;
  font-size: 14px;
}

.apply-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.apply-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 15px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  background: #fff;
}

.apply-item:hover {
  border-color: #422C27;
  background: #f8f9fa;
}

.apply-item.active {
  border-color: #422C27;
  background: #f0f7ff;
  box-shadow: 0 2px 8px rgba(66, 44, 39, 0.1);
}

.apply-radio {
  flex-shrink: 0;
  margin-top: 2px;
}

.apply-radio input[type="radio"] {
  width: 18px;
  height: 18px;
  cursor: pointer;
  accent-color: #422C27;
}

.apply-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.apply-title {
  text-align: left;
  font-size: 16px;
  font-weight: bold;
  color: #333;
}

.apply-details {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.apply-detail-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
}

.detail-label {
  color: #666;
  min-width: 80px;
  text-align: left;
}

.detail-value {
  color: #333;
  font-weight: 500;
}

.process-apply-modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 20px;
  border-top: 1px solid #eee;
  background: #f8f9fa;
  border-radius: 0 0 12px 12px;
}

.cancel-btn,
.reject-btn,
.submit-btn {
  padding: 10px 24px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
}

.cancel-btn {
  background: #f0f0f0;
  color: #666;
}

.cancel-btn:hover {
  background: #e0e0e0;
}

.reject-btn {
  background: #f44336;
  color: white;
}

.reject-btn:hover:not(:disabled) {
  background: #d32f2f;
}

.reject-btn:disabled {
  background: #ccc;
  color: #999;
  cursor: not-allowed;
  opacity: 0.6;
}

.submit-btn {
  background: #422C27;
  color: white;
}

.submit-btn:hover:not(:disabled) {
  background: #E4CEC2;
  color: #333;
}

.submit-btn:disabled {
  background: #ccc;
  color: #999;
  cursor: not-allowed;
  opacity: 0.6;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .process-apply-modal-content {
    width: 95%;
    max-width: 95%;
  }

  .apply-item {
    padding: 12px;
  }

  .apply-detail-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }

  .detail-label {
    min-width: auto;
  }
}
</style>

